(function () {
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function logIfFailed(promise, label) {
    return promise.then(function (r) {
      if (!r.ok) {
        r.text().then(function (t) { console.warn('[oversized-surcharge] ' + label + ' failed', r.status, t); });
      }
      return r;
    });
  }

  function reconcile(cart) {
    var cfg = window.DW_SURCHARGE;
    if (!cfg || !cfg.feeVariantId || !cart || !cart.items) return;

    var hasOversized = cart.items.some(function (item) {
      return cfg.productIds.indexOf(item.product_id) !== -1;
    });
    var feeLine = cart.items.filter(function (item) {
      return item.variant_id === cfg.feeVariantId;
    })[0];

    if (hasOversized && !feeLine) {
      logIfFailed(fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: cfg.feeVariantId, quantity: 1 }] })
      }), 'add fee').then(notifyCartChanged);
    } else if (!hasOversized && feeLine) {
      logIfFailed(fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: String(cfg.feeVariantId), quantity: 0 })
      }), 'remove fee').then(notifyCartChanged);
    } else if (hasOversized && feeLine && feeLine.quantity !== 1) {
      logIfFailed(fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: String(cfg.feeVariantId), quantity: 1 })
      }), 'normalize fee qty').then(notifyCartChanged);
    }
  }

  var suppressNextCheck = false;

  function checkCart() {
    if (suppressNextCheck) return;
    getCart().then(reconcile);
  }

  function notifyCartChanged() {
    suppressNextCheck = true;
    setTimeout(function () { suppressNextCheck = false; }, 800);
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
  }

  var CART_ENDPOINT_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = originalFetch.apply(this, arguments);
    if (CART_ENDPOINT_RE.test(url)) {
      result.then(function () {
        if (!suppressNextCheck) setTimeout(checkCart, 350);
      });
    }
    return result;
  };

  var OriginalXHR = window.XMLHttpRequest;
  function PatchedXHR() {
    var xhr = new OriginalXHR();
    var url = '';
    var origOpen = xhr.open;
    xhr.open = function (method, u) {
      url = u || '';
      return origOpen.apply(xhr, arguments);
    };
    xhr.addEventListener('loadend', function () {
      if (CART_ENDPOINT_RE.test(url) && !suppressNextCheck) {
        setTimeout(checkCart, 350);
      }
    });
    return xhr;
  }
  window.XMLHttpRequest = PatchedXHR;

  document.addEventListener('DOMContentLoaded', checkCart);
})();
